import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { partnerNameFromUrl } from "../../utils/constants";

export default function Nav() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(partnerNameFromUrl);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
